import './rules.scss';

import React from 'react';
import { SettingsContext } from 'context/context';
import { useContext } from 'react';

const Rules = ({rules}) => {
  const { state } = useContext(SettingsContext);

  return state.showRules && Object.keys(rules).length > 0 ? (
    <div className="rules">
      <h4>Rules</h4>
      { Object.keys(rules).map((ruleKey, index) => (
        <span key={index}>
          <p>
          <b dangerouslySetInnerHTML={{__html: `${rules[ruleKey].name}: ` }}/>
          <span dangerouslySetInnerHTML={{__html: rules[ruleKey].description}}/>
          </p>
        </span>
      )) }
    </div>
  ) : null;
};

export default Rules;
